import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import Navbar from '../components/Navbar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/reset-password`, { email });
      setSubmitted(true);
      toast.success('Password reset link sent! Check your email.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="booking-page" style={{ paddingTop: '100px' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', padding: '2rem' }}>
          {!submitted ? (
            <>
              <h1 className="booking-title" style={{ textAlign: 'center', marginBottom: '1rem' }}>
                Forgot Password
              </h1>
              <p style={{ textAlign: 'center', color: '#666', marginBottom: '2rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="cta-button"
                  disabled={loading}
                  style={{ width: '100%', marginTop: '1.5rem', justifyContent: 'center' }}
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>

              <p style={{ textAlign: 'center', marginTop: '1.5rem', color: '#666' }}>
                Remember your password?{' '}
                <Link to="/login" style={{ color: '#7c6f5e', fontWeight: 600 }}>
                  Log In
                </Link>
              </p>
            </>
          ) : (
            <>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📧</div>
                <h1 className="booking-title">Check Your Email</h1>
                <p style={{ color: '#666', marginTop: '1rem' }}>
                  If an account exists with {email}, you will receive a password reset link shortly.
                </p>
                <p style={{ color: '#666', marginTop: '1rem', fontSize: '0.875rem' }}>
                  The link will expire in 1 hour.
                </p>
                <Link to="/login">
                  <button
                    className="cta-button"
                    style={{ marginTop: '2rem' }}
                  >
                    Back to Login
                  </button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
